module.exports = __webpack_public_path__ + "static/data-science-course-301f6ef99040961fcb05991bc1a24890.svg";